import activeTrayManagementStore, {
  ActiveTrayManagementStore,
} from './active-tray-management-store';
import aimsPortalStore, { AIMSPortalStore } from './aims-portal-store';
import authStore, { AuthStore } from './auth-store';
import dashboardStore, { DashboardStore } from './dashboard-store';
import factoryScheduleStore, {
  FactoryScheduleStore,
} from './factory-schedule-store';
import factoryStore, { FactoryStore } from './factory-store';
import groupSettingStore, { GroupSettingStore } from './group-setting-store';
import kishuMarkStore, { KishuMarkStore } from './kishu-mark-store';
import operatorStore, { OperatorStore } from './operator-store';
import preferencesStore, { PreferencesStore } from './preferences-store';
import processStore, { ProcessStore } from './process-store';
import processTemplateStore, {
  ProcessTemplateStore,
} from './process-template-store';
import productStore, { ProductStore } from './product-store';
import teplarPrintStore, { TeplarPrintStore } from './teplar-print-store';
import trayManagementStore, {
  TrayManagementStore,
} from './tray-management-store';
import userLogsStore, { UserLogsStore } from './user-logs-store';
import userStore, { UserStore } from './user-store';
import checkItemTemplateStore, { CheckItemTemplateStore } from './check-item-template-store';
import dimensionStore, { DimensionStore } from './dimension-store';
import tagReassignStore, { TagReassignStore } from './tag-reassign-store';
import bomStore, { BOMStore } from './bom-store';


export type RootStore = {
  authStore: AuthStore;
  preferencesStore: PreferencesStore;
  userStore: UserStore;
  factoryStore: FactoryStore;
  processStore: ProcessStore;
  aimsPortalStore: AIMSPortalStore;
  processTemplateStore: ProcessTemplateStore;
  factoryScheduleStore: FactoryScheduleStore;
  productStore: ProductStore;
  teplarPrintStore: TeplarPrintStore;
  trayManagementStore: TrayManagementStore;
  groupSettingStore: GroupSettingStore;
  activeTrayManagementStore: ActiveTrayManagementStore;
  dashboardStore: DashboardStore;
  kishuMarkStore: KishuMarkStore;
  operatorStore: OperatorStore;
  userLogsStore: UserLogsStore;
  dimensionStore: DimensionStore;
  checkItemTemplateStore: CheckItemTemplateStore;
  tagReassignStore: TagReassignStore;
  bomStore: BOMStore
};

const rootStore: RootStore = {
  authStore,
  preferencesStore,
  userStore,
  factoryStore,
  processStore,
  aimsPortalStore,
  processTemplateStore,
  factoryScheduleStore,
  productStore,
  teplarPrintStore,
  trayManagementStore,
  groupSettingStore,
  activeTrayManagementStore,
  dashboardStore,
  kishuMarkStore,
  operatorStore,
  userLogsStore,
  dimensionStore,
  checkItemTemplateStore,
  tagReassignStore,
  bomStore
};

export default rootStore;
